import {useHostSelector} from 'hooks/hostHooks/hostHooks';
import {getRouter} from 'selectors/router';

/**
 * returns router data
 */
export const useGetRouter = () => {
    const router = useHostSelector(getRouter);

    return router;
};
